<template>
    
    <div >
        <base-form 
        :ajax="true"
		:error-scroll="true"
		:enable-validation-message="true"
		:action="'/participant/' + participant.id + '/updateWithContactInfo'" 
		id="participantEditForm" 
		class="form-horizontal"
		v-slot="{ state, update, loading }"
        @success="event => {submittedEdits(event)}" >
		
			<div class="col-md-1"></div>
			<div class="block col-md-10">
				
                <!-- <input type="hidden" name="participantId" :value="participant.id"> -->
                
                <div class="form-group">
                    <label class="col-sm-4 control-label">Id</label>
                    <div class="col-sm-8 tw-mt-2">
                        {{participant.id}}
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-sm-4 control-label">First Name</label>
                    <div class="col-sm-8">
                        <form-control name="firstName">
                            <input type="text" name="firstName" v-model="participant.firstName" class="input-sm">
                        </form-control>
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-sm-4 control-label">Middle Initial</label>
                    <div class="col-sm-8">
                        <form-control name="middleInitial">
                            <input type="text" name="middleInitial" v-model="participant.middleInitial" class="input-sm">
                        </form-control>
                    </div>
                </div>
                
                <div class="form-group">
                    <label class="col-sm-4 control-label">Last Name</label>
                    <div class="col-sm-8">
                        <form-control name="lastName">
                            <input type="text" name="lastName" v-model="participant.lastName" class="input-sm">
                        </form-control>
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-sm-4 control-label">Suffix</label>
                    <div class="col-sm-8">
                        <form-control name="suffix">
                            <input type="text" name="suffix" v-model="participant.suffix" class="input-sm">
                        </form-control>
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-sm-4 control-label">Nickname</label>
                    <div class="col-sm-8">
                        <form-control name="nametag" note="This will be used in your nametag(s)">
                            <input type="text" name="nametag" v-model="participant.nametag" class="input-sm" autocomplete="off">
                        </form-control>
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-sm-4 control-label">Title</label>
                    <div class="col-sm-8">
                        <form-control>
                            <input type="text" name="title" v-model="participant.title" class="input-sm">
                        </form-control>
                    </div>
                </div>	

            
                <div class="form-group">
                    <label class="col-sm-4 control-label">CIC/National Alliance Number</label>
                    <div class="col-sm-8 tw-mt-2">
                        {{participant.CICID}}
                    </div>
                </div>

                <div v-if="!participant.npn && !participant.noLicence" class="form-group tw-mb-6">
                    
                    <label class="col-md-4 control-label tw-pt-0">National Producer Number (NPN) 
                        <br class="tw-hidden lg:tw-block"> or License Number*
                    </label>
                
                    <div class="col-md-8">
                        <base-tray :blur-lock="true" :active="!participant.noLicense" :duration="500">
                            <div class="tw-block sm:tw-flex sm:tw-space-x-2 tw-pb-2">
                                <form-control name="npn" class="tw-mb-2 sm:tw-mb-0">
                                    <input type="text" name="npn">
                                </form-control>
                                <resident-states :selected="participant.residentState"></resident-states>
                            </div>
                        </base-tray>
                    
                        <form-control name="noLicense" :initial="false">
                            <label for="noLicense" class="tw-mb-0">
                                <input type="checkbox" name="noLicense" id="noLicense" v-model="participant.noLicense"> <strong>Not Licensed</strong>
                            </label>
                        </form-control>
                    </div>
                </div> 
                <div v-else>
                    <div class="form-group">
                        <label class="col-sm-4 control-label tw-pt-0">National Producer Number (NPN) <br>
                        or License Number</label>
                        <div class="col-sm-8 tw-mt-2" style="max-width: 300px">
                            {{participant.noLicence ? "No License" : participant.npn}} 

                        </div>
                    </div>
                    
                    <div class="form-group" :class="{'tw-opacity-50':participant.noLicense}">
                        <label class="col-sm-4 control-label">Resident State</label>
                        <div class="col-sm-8">
                            <resident-states :selected="participant.residentState"></resident-states>
                        </div>
                    </div> 
                </div> 
                <div class="form-group">
                    <div class="col-sm-8 col-sm-offset-4">
                        <div>
                            <input 
                            type="checkbox" 
                            name="magazine" 
                            v-model="magazine">
                            Yes, I want the PIA Magazine
                        </div>
                        <div>
                            <input 
                            type="checkbox" 
                            name="mailing" 
                            v-model="mailing"
                            >
                            Yes, I want the PIA Monthly Mailing on Upcoming Events
                        </div>
                        <div>
                            <input 
                            type="checkbox" 
                            name="parttime" 
                            v-model="parttime"
                            >
                            Part-time Employee
                            <input type="hidden" name="companyId" :value="company.id"> 
                        </div>
                    </div>
                </div>
                <hr>
                <!-- Email -->
                <div class="tw-mb-8 tw-mt-4">
                    <div class="tw-flex tw-gap-2 tw-items-center tw-mb-6">
                        <h2>Primary Email</h2>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8 ">
                            <form-control name="primaryEmailId" >
                                <select name="primaryEmailId" style="width: 250px;" v-model="primaryEmailId">	
                                
                                    <optgroup label="Emails on profile">
                                        <option v-for="email of emails" :value="email.id">{{email.email}}  </option>
                                    </optgroup>
                                    
                                    <optgroup :label="company.name + ' Emails'">
                                        <option v-for="email of companyEmails" :value="email.id">{{email.email}} </option>
                                    </optgroup> 
                                    <option value="newEmail">New Email</option>
                                </select>
                            </form-control>
                        </div>
                    </div>
                    
                    <div v-show="primaryEmailId == 'newEmail'">
                        <!-- Personal Email - there aren't company emails - allow editing -->
                        <div class="form-group row">
                            <label class="col-md-4 control-label">Email* </label>
                            <div name="email" class="col-md-8">
                                <form-control name="email">
                                    <input type="text" name="email" style="width:250px;">
                                </form-control>
                            </div>
                        </div>
                       
                        <div class="form-group row">
                            <label class="col-md-4 control-label">Email Type*</label>
                            <div class="col-md-8">
                                <form-control name="emailType">
                                    <select name="emailType" id="emailType">
                                        <option value="business">Business</option>
                                        <option value="personal">Personal</option>
                                    </select>
                                </form-control>
                            </div>
                        </div>
                    </div>
                
                </div>
                <hr>
                <!-- Address -->
                <div class="tw-mb-8 tw-mt-4">
                    <div class="tw-flex tw-gap-2 tw-items-center tw-mb-6">
                        <h2>Primary Address</h2>
                    </div>
                    
                    <div class="form-group">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8 ">
                            <form-control name="primaryAddressId" >
                                <select name="primaryAddressId" style="width: 250px;" v-model="primaryAddressId">	
                                
                                    <optgroup label="Addresses on profile">
                                        <option v-for="address of addresses" :value="address.id">{{address.line1}} {{address.line2}} {{address.city && address.state ? address.city + ', ' + address.state : address.city + address.state}} {{address.zip_code}}  </option>
                                    </optgroup>
                                    
                                    <optgroup :label="company.name + ' Addresses'">
                                        <option v-for="address of companyAddresses" :value="address.id">{{address.line1}} {{address.line2}} {{address.city && address.state ? address.city + ', ' + address.state : address.city + address.state}} {{address.zip_code}} </option>
                                    </optgroup> 
                                    <option value="newAddress">New Address</option>
                                </select>
                            </form-control>
                        </div>
                    </div>
                    <div v-show="primaryAddressId == 'newAddress'">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">Line 1* </label>
                            <div class="col-sm-8">
                                <form-control name="line1">
                                    <input type="text" name="line1">
                                </form-control>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-4 control-label">Line 2</label>
                            <div class="col-sm-8">
                                <form-control name="line2">
                                    <input type="text" name="line2">
                                </form-control>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-4 control-label">City/Town*</label>
                            <div class="col-sm-8">
                                <form-control name="city">
                                    <input type="text" name="city">
                                </form-control>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-4 control-label">State*</label>
                            <div class="col-sm-8">
                                <resident-states var-name="state" ></resident-states>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-4 control-label">Zip Code*</label>
                            <div class="col-sm-8">
                                <form-control name="zip_code">
                                    <input type="text" name="zip_code">
                                </form-control>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-4 control-label">Address Type {{user_is_pia ? '' : "*"}}</label>

                            <form-control name="addressType" class="col-sm-8" key="{{ Str::random(20) }}" >	
                                <select name="addressType" v-model="state.address_type" style="max-width: 200px;" @change="hide(['otherAddressType'])">
                                    <option value=""></option>
                                    <option value="office">Office</option>
                                    <option value="home">Home</option>
                                    <option value="po-box">PO Box</option>
                                    <option value="other">Other</option>
                                </select>
                            </form-control>	
                        </div>

                        <div class="form-group" v-show="state.address_type == 'other'">
                            <form-control name="otherAddressType" class="col-sm-8 col-sm-offset-4" key="{{ Str::random(20) }}" style="max-width: 300px">
                                <input type="text" name="otherAddressType" placeholder="Enter Address Type" v-model="state.other_address_type">
                            </form-control>
                        </div>
                    </div>
                
                    
                </div>
                <hr>
                <!-- Phone -->
                <div class="tw-mb-8 tw-mt-4">
                    <div class="tw-flex tw-gap-2 tw-items-center tw-mb-6">
                        <h2>Primary Phone</h2>
                    </div>
                    
                    <div class="form-group">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8 ">
                            <form-control name="primaryPhoneId" >
                                <select name="primaryPhoneId" style="width: 250px;" v-model="primaryPhoneId">	
                                
                                    <optgroup label="Phones on profile">
                                        <option v-for="phone of phones" :value="phone.id">{{phone.area_code}} {{ phone.digit_7_num.replace(/^(\d{3})/, '$&-') }}<span v-if="phone.ext"> ext. {{phone.ext}}</span> </option>
                                    </optgroup>
                                    
                                    <optgroup :label="company.name + ' Phones'">
                                        <option v-for="phone of companyPhones" :value="phone.id">{{phone.area_code}} {{ phone.digit_7_num.replace(/^(\d{3})/, '$&-') }}<span v-if="phone.ext"> ext. {{phone.ext}}</span> </option>
                                    </optgroup> 
                                    <option value="newPhone">New Phone</option>
                                </select>
                            </form-control>
                        </div>
                    </div>
                    <div v-show="primaryPhoneId == 'newPhone'"> 
                        
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8 tw-my-4">
                            
                            <phone-block area-code-name="areaCode" digit7-num-name="digit7Num" ext-name="ext">
                                <template #area-code="slotProps"> 

                                    <div class="tw-flex tw-items-center tw-space-x-1">
                                        <p class="tw-text-lg">(</p>
                                        <form-control name="areaCode" :portal-errors="true" portal-to="areaCode" initial="">
                                            <input type="text" v-model="state.area_code" name="areaCode" style="width: 50px" maxlength="3" v-on:input="slotProps.changeBox" >
                                        </form-control>
                                        <p class="tw-text-lg">)</p>
                                    </div>
                                </template>
                                <template #digit-seven-num="slotProps">
                        
                                    <div class="tw-mx-2">
                                        <form-control name="digit7Num" :portal-errors="true" portal-to="digit7Num" initial="">
                                            <input type="text" v-model="state.digit7Num" name="digit7Num" style="width: 100px" maxlength="8" v-on:input="slotProps.changeBoxExt" >
                                        </form-control>
                                    </div>
                            
                                </template>
                                <template #ext="slotProps">
                                    <div class="tw-flex tw-space-x-1">
                                        <label class="tw-mt-2">ext.</label>
                                        <div>
                                            <form-control name="ext" :portal-errors="true" portal-to="ext" initial="">
                                                <input type="text" v-model="state.ext" name="ext" id="ext" style="width: 50px">
                                            </form-control>
                                        </div>
                                    </div>
                                </template>		
                            </phone-block>
                            <portal-target name="areaCode"></portal-target>
		                    <portal-target name="digit7Num"></portal-target>
		                    <portal-target name="ext"></portal-target>
                        </div>
                        
                        <div class="form-group">
                            <div class="col-sm-4 control-label tw-mt-2"><label>Phone Type*</label></div>
                            <div class="col-sm-8">
                                <div class=" tw-mt-3">
                                    <form-control name="phoneType" >
                                        <select name="phoneType" v-model="state.phone_type" style="max-width: 200px;" >
                                            <option value="cell">Cell</option>
                                            <option value="home">Home</option>
                                            <option value="office">Office</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </form-control>
                                </div>
                            </div>
                         </div>
                        <div class="form-group" v-show="state.phone_type == 'other'">
                            <form-control name="otherPhoneType" class="col-sm-8 col-sm-offset-4">
                                <input type="text" name="otherPhoneType" style="max-width: 300px;" placeholder="Enter Phone Type">
                            </form-control>
                        </div>
                       
                    </div>
                    <br>
                
                </div>
                
                <div class="block-footer tw-flex tw-sticky tw-bottom-0 tw-p-4 tw-backdrop-blur-sm tw-border-t tw-bg-gradient-to-t tw-from-white tw-to-transparent">
                    <submit-button type="submit" class="btn-success" :loading="loading" >Submit Edits</submit-button>
                    <button type="button" class="btn" @click="goBack">Back</button>
                    
                </div>
            </div>   
		</base-form>
	</div>
    
</template>

<script>
import ResidentStates from './ResidentStates.vue';
export default {
  components: { ResidentStates },
    name: "EditParticipant",

    props: {
        participant: {
            type: Object,
            required: true
        },
        company: {
            type: Object,
            required: false,
        },
        user_is_pia:{
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            phones: [],
            addresses: [],
            emails: [],
            primaryPhoneId: null,
            primaryAddressId: null,
            primaryEmailId: null,
            companyAddresses: [],
            companyPhones: [],
            companyEmails: [],
            mailing: (this.participant.hasMailingKeycode || this.participant.hasMagAndMailingKeycode) ? true : false,
            magazine: (this.participant.hasMagazineKeycode || this.participant.hasMagAndMailingKeycode) ? true : false,
            parttime: this.participant.companies.find(item => item.id == this.company.id).pivot.parttime ? true : false,
        }
    },

    watch:{
        participant(newP){
            this.updateInfo(newP);
            
            this.getCompanyInfo();
        }
    },
    mounted() {
        //this.companyAddresses.forEach(function(a){ console.log(a); });
        this.updateInfo(this.participant);
        this.getCompanyInfo();
        console.log('mounted');
        console.log(this.participant.companies.find(item => item.id == this.company.id).pivot.parttime);
        //EventBus.$on('updated-participant', this.refreshParticipant);
    },

    methods: {
        get() {
            
        },
        submitForm(){
            uri = '/participant/' + this.participant.id + '/update';
            axios.get(uri, {
                    params: this.queryParameters
                })
                .then(response => {
                    console.log('data-fetch submitForm', response.data);
                    this.items = response.data;

                    // Store additional data
                    if(response.data.store) {
                        for(let [key, value] of Object.entries(response.data.store)) {
                            this.$set(this.store, key, value);
                        }
                    }
                    //this.$emit('update', response.data);
                    this.submittedEdits(response.data);
                    this.loading = false;
                })
        },
        
        submittedEdits(participant){
            console.log('submitting edits'); 
            let participantId = participant.id;
            EventBus.$emit('updated-participant', participantId);
            this.$emit('updated-participant', participantId);
        },

        updateInfo(newP){
            console.log('filling participant info');

            this.primaryAddressId = null;
            this.primaryEmailId = null;
            this.primaryPhoneId = null;

            this.emails = [];
            this.phones = [];
            this.addresses = [];

            axios.get('/api/participant/' + newP.id + '/emails')
                    .then(response => {
                        this.emails = response.data.data;
                        this.primaryEmailId = this.participant.primary_email_id ?? null;
                    });
            axios.get('/api/participant/' + newP.id + '/phones')
                    .then(response => {
                        this.phones = response.data.data;
                        this.primaryPhoneId = this.participant.primary_phone_id ?? null;
                    });
            axios.get('/api/participant/' + newP.id + '/addresses')
                    .then(response => {
                        this.addresses = response.data.data;
                        this.primaryAddressId = this.participant.primary_address_id ?? null;
                    });

            this.mailing = (this.participant.hasMailingKeycode || this.participant.hasMagAndMailingKeycode) ? true : false;
            this.magazine = (this.participant.hasMagazineKeycode || this.participant.hasMagAndMailingKeycode) ? true : false;
            this.parttime = this.participant.companies.find(item => item.id == this.company.id).pivot.parttime ? true : false;

           
            console.log("participant:", this.participant);
            
            
            
            
            console.log('new primary address: ' + this.primaryAddressId + ', ' + this.primaryEmailId + ', ' + this.primaryPhoneId);
            
        },

        getCompanyInfo(){
            console.log('updating company info');
            axios.get('/api/company/' + this.company.id + '/addresses')
                    .then(response => {
                        //console.log('company addresses: ', response.data.data);
                        this.companyAddresses = response.data.data;
                    });

            axios.get('/api/company/' + this.company.id + '/phones')
                    .then(response => {
                        //console.log('company phones: ', response.data.data);
                        this.companyPhones = response.data.data;
                    });

            axios.get('/api/company/' + this.company.id + '/emails')
                    .then(response => {
                        //console.log('company emails: ', response.data.data);
                        this.companyEmails = response.data.data;
                    });
        },

        goBack(){
            console.log('going back');
            //EventBus.$emit('back-to-membership');
            
            this.$emit('back-to-membership');
            
        }
    }
}
</script>

<style>

</style>